var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEvHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2232_14173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 19.3086V32.0006C15 32.2658 15.1054 32.5202 15.2929 32.7077C15.4804 32.8952 15.7348 33.0006 16 33.0006H32C32.2652 33.0006 32.5196 32.8952 32.7071 32.7077C32.8946 32.5202 33 32.2658 33 32.0006V19.3086",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 23L24 11L11 23",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7.55024V22.8242C3.05876 27.8712 4.66716 32.7782 7.60737 36.8807C10.5476 40.9831 14.6776 44.0829 19.438 45.7602L21.68 46.5882C23.1778 47.1383 24.8222 47.1383 26.32 46.5882L28.562 45.7602C33.3224 44.0829 37.4524 40.9831 40.3926 36.8807C43.3328 32.7782 44.9412 27.8712 45 22.8242V7.55024C44.998 6.95015 44.8199 6.36384 44.4879 5.86399C44.1558 5.36413 43.6844 4.97271 43.132 4.73824C37.0736 2.20954 30.5647 0.937834 24 1.00024C17.4353 0.937834 10.9264 2.20954 4.868 4.73824C4.31561 4.97271 3.84418 5.36413 3.51213 5.86399C3.18007 6.36384 3.00201 6.95015 3 7.55024Z",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 33V28C21 27.2044 21.3161 26.4413 21.8787 25.8787C22.4413 25.3161 23.2044 25 24 25C24.7956 25 25.5587 25.3161 26.1213 25.8787C26.6839 26.4413 27 27.2044 27 28V33",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2232_14173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvHome);
export default __webpack_public_path__ + "static/media/icon-ev-home.697a293f2d921a1e24853bc1eec1f784.svg";
export { ForwardRef as ReactComponent };